import {
    useAPIQuery,
    useGlobalAPIQueryContext,
} from "@dev2_techwalnut/tw-api-query-hook";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import secureLocalStorage from "react-secure-storage";
import Select from "react-select";
import Swal from "sweetalert2";
import SelectAll from "../../Base/SelectAll";

const CreateQualityParameterModal = (props) => {
    console.log(props);
    const { invalidateApi } = useGlobalAPIQueryContext();
    const userID = secureLocalStorage.getItem("userID");

    // select dropdown
    const [unit, setUnit] = useState([]);
    const [item, setItem] = useState([]);
    const [specificationType, setSpecificationType] = useState([]);

    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
        reset,
        setValue,
    } = useForm({ mode: "onChange" });

    const { useFetch } = useAPIQuery({
        key: "api/generic",
        endpoint: "/api/generic/",
    });

    const { data, isLoading } = useFetch({
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const { useFetch: useQualityParams, useCreate } = useAPIQuery({
        key: "quality_parameter",
        endpoint: "/api/quality-parameters/",
    });

    const {
        data: qualityParamsDropdown,
        isLoading: loadingQualityParamsDropdown,
    } = useQualityParams({
        params: {
            action: "fetch-params",
        },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const handleCreateQualityParameter = (data) => {
        Swal.fire({
            title: "Quality Parameter Added!",
            text: data?.message,
            icon: "success",
        }).then((result) => {
            invalidateApi({ key: "item-parameter-association" });
            if (result.isConfirmed) {
                setTimeout(() => {
                    reset({
                        parameter_name: "",
                        unit: "",
                        // rule_type: "",
                        item_id: props?.item ? [props?.item] : [],
                        // specifications_type: "",
                    });
                    const button = document.createElement("button");
                    button.className = "d-none";
                    button.setAttribute(
                        "data-bs-target",
                        "#create-quality-parameters-modal"
                    );
                    button.setAttribute("data-bs-dismiss", "modal");
                    document.body.appendChild(button);
                    button.click();
                    button.remove();
                }, 2000);
            }
        });
    };

    const handleErrorQualityParameter = (data) => {
        Swal.fire({
            title: "Error Adding Quality Parameter",
            text: data?.data?.data?.message,
            icon: "error",
        });
    };

    const { mutate, isPending } = useCreate({
        params: {
            action: "item_association",
        },
        onSuccess: handleCreateQualityParameter,
        onError: handleErrorQualityParameter,
        retry: 2,
    });

    const onSubmit = (data) => {
        console.log(data);
        var quality_parameter = {
            parameter_name: data.parameter_name,
            unit: data.unit?.value,
            // rule_type: data.rule_type,
            item_ids: data.item_id?.map((info) => info.value),
            // specifications_type: "",
            created_by: userID,
            updated_by: userID,
        };

        console.log(quality_parameter);

        mutate({
            data: quality_parameter,
        });
    };
    useEffect(() => {
        if (data) {
            setUnit(
                data?.typemaster?.filter(
                    (post) => post.category_value == "unit_of_measurement"
                )
            );
            setSpecificationType(
                data?.typemaster?.filter(
                    (post) => post.category_value == "specification_type"
                )
            );
            setItem(data.item);
        }
    }, [data]);
    useEffect(() => {
        if (props?.item) {
            setValue("item_id", [props?.item]);
        }
    }, [props?.item]);
    useEffect(() => {
        return () => {
            const backdrop = document.querySelector(".modal-backdrop");
            if (backdrop) {
                backdrop.remove();
                document.body.classList.remove("modal-open");
                document.body.style = "";
            }
        };
    }, []);
    return (
        <div
            className="modal fade m-0 p-0"
            tabIndex={-1}
            id={`create-quality-parameters-modal`}
            aria-modal
        >
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <button className="close" data-bs-dismiss="modal">
                        <em
                            className="icon ni ni-cross"
                            aria-hidden="true"
                        ></em>
                    </button>
                    <div className="modal-header">
                        <h5 className="modal-title">Add Quality Parameter</h5>
                    </div>
                    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                        <div className="modal-body">
                            <div className="row g-4">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Parameter Name
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={
                                            loadingQualityParamsDropdown
                                                ? "Loading..."
                                                : "Enter parameter name"
                                        }
                                        id="text-forms-parameter-name"
                                        {...register("parameter_name", {
                                            required:
                                                "Parameter Name is required",
                                            validate: (value) => {
                                                if (!value) return true;
                                                const exists =
                                                    qualityParamsDropdown?.data?.some(
                                                        (param) =>
                                                            param.toLowerCase() ===
                                                            value.toLowerCase()
                                                    );
                                                return exists
                                                    ? "This parameter already exists"
                                                    : true;
                                            },
                                        })}
                                        disabled={loadingQualityParamsDropdown}
                                    />

                                    {errors.parameter_name && (
                                        <span className="fs-8 text-danger">
                                            {errors.parameter_name.message}
                                        </span>
                                    )}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Unit
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <Controller
                                        render={({ field }) => (
                                            <SelectAll
                                                {...field}
                                                options={unit?.map((info) => ({
                                                    value: info.name,
                                                    label: info.name,
                                                }))}
                                                isLoading={isLoading}
                                                isClearable={true}
                                                id="select-forms-unit"
                                            />
                                        )}
                                        defaultValue=""
                                        rules={{ required: true }}
                                        name="unit"
                                        control={control}
                                    />
                                    {errors.unit && (
                                        <span className="fs-8 text-danger">
                                            Unit is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Item Name
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <Controller
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={item
                                                    ?.filter(
                                                        (i) =>
                                                            i?.category?.toLowerCase() ===
                                                                "Raw Material"?.toLowerCase() ||
                                                            i?.category?.toLowerCase() ===
                                                                "WIP"?.toLowerCase()
                                                    )
                                                    ?.map((info) => ({
                                                        value: info?.id,
                                                        label: info?.item_name,
                                                    }))}
                                                isLoading={isLoading}
                                                isClearable={true}
                                                id="select-forms-item-id"
                                                isMulti
                                                isDisabled
                                            />
                                        )}
                                        defaultValue=""
                                        rules={{ required: true }}
                                        name="item_id"
                                        control={control}
                                    />
                                    {errors.item_id && (
                                        <span className="fs-8 text-danger">
                                            Item Name is required
                                        </span>
                                    )}
                                </div>

                                {/* <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Rule Type
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter rule type"
                                        id="text-forms-rule-type"
                                        {...register("rule_type", {
                                            required: true,
                                        })}
                                    />
                                    {errors.rule_type && (
                                        <span className="fs-8 text-danger">
                                            Rule Type is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Specification Type
                                    </label>
                                    <Controller
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={specificationType?.map(
                                                    (info) => ({
                                                        value: info.name,
                                                        label: info.name,
                                                    })
                                                )}
                                                isLoading={isLoading}
                                                isClearable={true}
                                                id="select-forms-specification-type"
                                            />
                                        )}
                                        defaultValue=""
                                        rules={{ required: false }}
                                        name="specifications_type"
                                        control={control}
                                    />
                                    {errors.specifications_type && (
                                        <span className="fs-8 text-danger">
                                            Specification Type is required
                                        </span>
                                    )}
                                </div> */}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-light"
                                data-bs-dismiss="modal"
                                disabled={isPending}
                            >
                                Close
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={isPending}
                            >
                                {isPending ? "Loading..." : "Add"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CreateQualityParameterModal;
